import { useSelector } from "react-redux";
import { EpiLinks, StoreState } from "../interfaces/storeState";

export const useEpiserverLink = (): EpiLinks => useSelector(getEpiserverLink);

const getEpiserverLink = (state: StoreState): EpiLinks => {
  if (!state.epiLinks) {
    return undefined;
  }

  return state.epiLinks;
};
